/**
 * Creator Agreement 生效时间戳（ms）。
 * 申请时间 > 生效时间，才展示协议勾选并做提交限制。
 */

// 这里的时间应该是上线时间 北京时间 2026-07-16 18:17:47 生成
export const CREATOR_AGREEMENT_EFFECTIVE_AT = 1784225867000;

function toTimestamp(value: number | string | Date): number {
  if (typeof value === 'number') {
    return value;
  }
  const timestamp = new Date(value).getTime();
  return Number.isNaN(timestamp) ? NaN : timestamp;
}

function isEmptyOrderDate(
  orderDate: number | string | Date | null | undefined
): boolean {
  return (
    orderDate == null ||
    orderDate === '' ||
    (typeof orderDate === 'number' && Number.isNaN(orderDate))
  );
}

// 订单申请时间，迟于上线时间 才展示协议勾选并做提交限制
export function shouldRequireCreatorAgreement(
  orderDate?: number | string | Date | null
): boolean {
  if (isEmptyOrderDate(orderDate)) {
    return true;
  }
  const orderTimestamp = toTimestamp(orderDate as number | string | Date);
  if (Number.isNaN(orderTimestamp)) {
    return true;
  }
  return CREATOR_AGREEMENT_EFFECTIVE_AT < orderTimestamp;
}
